import { useContext } from 'react';
import styled, { ThemeContext } from 'styled-components';
import {
  SecondaryButton,
  InfoCircleIcon,
  CheckCircleIcon,
  GavelIcon,
  GraysTheme,
  BodyText,
  breakpoint,
  CheckIcon,
} from '@grays-npm/component-library';
import NotificationCard from './NotificationCard';

export type NotificationProps = {
  id: string;
  iconType: 'info' | 'gavel' | 'check';
  buttonText?: string;
  buttonPath?: string;
  titleText: string;
  text: string;
  isRead?: boolean;
};

export type NotificationListProps = {
  notifications: NotificationProps[];
  emptyText: string;
};

const ButtonWrapper = styled.div`
  width: fit-content;
  min-width: 128px;
  padding-top: ${({ theme }) => theme.spacings[2].rem};

  ${breakpoint('lg')`
    min-width: 120px;
    padding-top: 0;
  `}
`;

const NoNotificationText = styled(BodyText)`
  font-weight: 700;
  text-align: center;
`;

const switchIcon = (iconType: string, theme: GraysTheme) => {
  const {
    primary: { graysBlue },
    system: { systemGreen },
  } = theme.colors;

  switch (iconType) {
    case 'gavel':
      return { SvgIcon: GavelIcon, color: graysBlue };
    case 'check':
      return { SvgIcon: CheckCircleIcon, color: systemGreen };
    case 'info':
    default:
      return {
        SvgIcon: InfoCircleIcon,
        color: graysBlue,
      };
  }
};

const Close = styled.div<{ isRead?: boolean }>`
  position: absolute;
  fill: ${({ theme, isRead }) =>
    isRead
      ? theme.colors.system.systemGreen
      : theme.colors.neutrals.solidGrays[4]};
  top: ${({ theme }) => theme.spacings[2].px};
  right: ${({ theme }) => theme.spacings[2].px};
  cursor: pointer;
  transition: all 0.2s ease-in-out;

  &:hover {
    fill: ${({ theme }) => theme.colors.system.systemGreen};
    transform: scale(1.2);
  }

  ${breakpoint('lg')`
    position: inherit;
  `}
`;

export const NotificationList: React.FC<NotificationListProps> = ({
  notifications,
  emptyText,
}) => {
  const theme = useContext(ThemeContext);

  const onDismiss = () => {
    //TODO: on dismiss
  };

  const onNotificationClick = (e: React.MouseEvent<HTMLElement>) => {
    console.log(e);
  };

  const showNotifications = notifications && notifications.length > 0;

  return (
    <>
      {showNotifications ? (
        notifications.map(
          ({
            id,
            iconType,
            buttonText,
            buttonPath,
            isRead,
            ...notification
          }) => {
            const { SvgIcon, color } = switchIcon(iconType, theme);
            return (
              <NotificationCard
                key={id}
                SvgIcon={SvgIcon}
                color={color}
                onClick={onNotificationClick}
                buttonContents={
                  buttonText && (
                    <ButtonWrapper>
                      <SecondaryButton
                        // onClick={() => history.pushState(buttonPath))} - TODO: React Router Routing
                        size="small"
                        fullWidth
                      >
                        {buttonText}
                      </SecondaryButton>
                    </ButtonWrapper>
                  )
                }
                dismissContent={
                  <Close onClick={onDismiss} isRead={isRead}>
                    <CheckIcon width={32} />
                  </Close>
                }
                {...notification}
              ></NotificationCard>
            );
          }
        )
      ) : (
        <NoNotificationText size="lg">{emptyText}</NoNotificationText>
      )}
    </>
  );
};
